












import dayjs from 'dayjs'
import {
  Vue, Component, Prop, Watch, Mixins,
} from 'vue-property-decorator'
import MainMixin from '../../mixins/MainMixin'
import EventBus from '../../event-bus'

@Component({
  components: {
  },
})
export default class CTimePicker extends Mixins(MainMixin) {
  @Prop({ default: false }) showLabel!:boolean

  get now() {
    return dayjs(new Date()).format('HH:mm')
  }

  tempTime = this.now

  isNow = true

  dialog = false

  timeValue = dayjs(new Date()).format('HH:mm')

  get displayTime() {
    return dayjs(new Date()).hour(Number(this.timeValue.substr(0, 2))).minute(Number(this.timeValue.substr(3, 2))).format('h:mma')
  }

  checkCheckbox() {
    if (this.isNow) {
      this.timeValue = this.now
      this.$emit('update:value', this.timeValue)
    } else {
      this.dialog = true
    }
  }

  setTime() {
    console.log('temptime: ', this.tempTime)
    this.timeValue = this.tempTime
    if (this.tempTime === this.now) {
      this.isNow = true
    } else this.isNow = false
    this.dialog = false
    this.$emit('update:value', this.timeValue)
  }

  @Watch('now')
  checkNow(newValue:string) {
    if (this.isNow) {
      this.timeValue = newValue
    }
  }

  reset() {
    this.timeValue = this.now
    this.isNow = true
    this.$emit('update:value', this.timeValue)
  }

  created() {
    this.$emit('update:value', this.timeValue)
    // this.EventBus.$on('switch-tab', (tab:string) => {
    //   console.log('ok')
    // })
  }
}

